export const templatesIndex = {
  header: {
    title: "Szablony WhatsApp",
    description:
      "Tworzenie i edycja szablonów tak jak w Meta (nagłówek/treść/stopka/przyciski + podgląd).",
    create: "Utwórz szablon",
  },
  notConnected:
    'To konto nie ma podłączonego WhatsApp Business (WABA). Najpierw należy podłączyć je w sekcji "WhatsApp Business".',
  filters: {
    search: "Szukaj",
    searchPlaceholder: "Szukaj po nazwie...",
    status: "Status",
    all: "Wszystkie",
    category: "Kategoria",
    allFem: "Wszystkie",
    language: "Język",
    refresh: "Odśwież",
  },
  list: {
    loading: "Wczytywanie szablonów...",
    emptyTitle: "Brak szablonów",
    emptyText: "Proszę zmienić filtry albo utworzyć pierwszy szablon.",
    baseBadge: "Bazowy",
    edit: "Edytuj",
    duplicate: "Duplikuj",
    deleteProtected: "Szablon bazowy: nie można go usunąć",
    delete: "Usuń",
    prev: "← Poprzednie",
    next: "Następne →",
  },
  preview: {
    noText: "(brak tekstu)",
    noContent: "Brak treści",
  },
  time: {
    now: "Teraz",
    minutesAbbr: "{n} min",
    hoursAbbr: "{n} godz.",
  },
  common: {
    close: "Zamknij",
    cancel: "Anuluj",
  },
  editor: {
    createTitle: "Utwórz szablon",
    editTitle: "Edytuj szablon",
    sectionBasic: "Podstawowe",
    name: "Nazwa (snake_case)",
    nameHintHtml:
      "Spacje zamieniają się na <code>_</code>. Tylko <code>a-z</code>, <code>0-9</code> i <code>_</code>.",
    language: "Język",
    category: "Kategoria",
    sectionHeader: "Nagłówek",
    enable: "Włącz",
    type: "Typ",
    headerLocationHintHtml:
      "Nagłówek typu LOCATION nie zawiera w szablonie tekstu ani przykładów. Lokalizacja (lat/lng + nazwa/adres) jest wysyłana przy dostarczeniu wiadomości przez <code>/messages</code>.",
    headerMediaHint:
      "Przy użyciu MEDIA konto może wymagać przykładów/uchwytów podczas weryfikacji.",
    headerTextLabel: "Tekst (maks. 60)",
    headerTextPlaceholder: "Np. Dzień dobry {{1}}, rezerwacja jest gotowa.",
    insert: "Wstaw",
    autoExample: "Przykład automatyczny",
    examplesHeader: "Przykłady (nagłówek)",
    remove: "Usuń",
    headerLocationNote: "Na początku wiadomości zostanie wysłana karta z mapą.",
    headerMediaNote: "Ten nagłówek będzie pokazany jako załącznik (media).",
    sectionBody: "Treść",
    bodyPlaceholder: "Proszę wpisać treść. Można użyć {{1}}, {{2}}...",
    examplesBody: "Przykłady (treść)",
    sectionFooter: "Stopka",
    footerPlaceholder: "Krótki tekst (opcjonalnie, maks. 60)",
    sectionButtons: "Przyciski",
    addButton: "+ Dodaj",
    noButtons: "Brak przycisków (opcjonalnie).",
    buttonTextPlaceholder: "Tekst przycisku (maks. 25)",
    removeButton: "Usuń",
    previewTitle: "Podgląd",
    viewPayload: "Zobacz payload wysyłany do Meta",
    metaDebug: "Odpowiedź / błąd Meta (debug)",
    validReady: "Gotowe do zapisania.",
    validIncomplete: "Przed zapisaniem trzeba uzupełnić wymagane pola.",
    saving: "Zapisywanie...",
    save: "Zapisz",
  },
  delete: {
    title: "Usuń szablon",
    irreversible: "Tej operacji nie da się cofnąć.",
    willDeletePre: "Szablon ",
    willDeletePost: " zostanie usunięty.",
    confirmLabel: "Proszę wpisać dokładną nazwę, aby potwierdzić:",
    confirmPlaceholder: "Proszę wpisać nazwę dokładnie",
    confirmHint: "Przycisk włącza się, gdy tekst zgadza się co do znaku.",
    deleting: "Usuwanie...",
    confirmDelete: "Usuń na stałe",
  },
  errors: {
    nameRequired: "Nazwa jest wymagana.",
    nameInvalid: "Nieprawidłowy format. Dozwolone są tylko a-z, 0-9 i _.",
    headerRequired: "Tekst nagłówka jest wymagany, gdy nagłówek jest włączony.",
    headerMax: "Tekst nagłówka może mieć maks. 60 znaków.",
    bodyRequired: "Treść jest wymagana.",
    bodyMax: "Treść może mieć maks. 1024 znaki.",
    footerMax: "Stopka może mieć maks. 60 znaków.",
    buttonTextRequired: "Tekst przycisku jest wymagany.",
    buttonTextMax: "Maks. 25 znaków.",
    phoneInvalid: "PHONE_NUMBER musi być w formacie E.164 (np. +34123456789).",
    urlInvalid: "URL musi zaczynać się od http:// albo https://",
    loadDetail: "Nie udało się wczytać szczegółów szablonu.",
    save: "Błąd podczas zapisywania szablonu.",
    deleteFailed: "Nie udało się usunąć szablonu.",
  },
  duplicate: {
    defaultBody: "Kopia szablonu. Proszę zmienić treść. Dziękujemy {{1}}.",
  },
};
